module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG2f6b66d68bbf1e0d9ae2e8add6d8383d.2f6b66d6.png";